/**
 * Formats a price value for Slovak UI.
 */
export function formatPrice(value?: number) {
  return typeof value === 'number'
    ? `${value.toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
    : '-';
}

/**
 * Formats an API date-time value for Slovak UI.
 */
export function formatDateTime(value?: string) {
  return value ? new Date(value).toLocaleString('sk-SK') : '-';
}

/**
 * Formats a user display name with a stable fallback.
 */
export function formatPerson(person?: { fullName?: string; firstName?: string; lastName?: string }) {
  const name = [person?.firstName, person?.lastName].filter(Boolean).join(' ');
  return person?.fullName || name || '-';
}
